import { Injectable } from '@angular/core'

@Injectable({ providedIn: 'root' })

export class AvailabilityConstants {
	selectBoxFieldType = "SELECT_BOX";
	textBoxFieldType = "TEXT_BOX";
	toggleFieldType = "TOGGLE";
	readonlyFieldType = "READONLY";
	studyBCERLimit = 7;
	notSupplied = 'Not supplied';
	removeAlertMsg = 'Are you sure, you want to remove the er qualification?';
	minMaxError = 'Please enter either the Min or Max points. Both fields cannot be left blank.';
	monthList = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
	availabilityAttrIds = {
		bcDurationAttrId: 44,
		bcPostcodeAttrId: 56
	}
	businessLine = 'businessLine';
	businessLineList = [{ id: 'SP', name: 'Student placement', hideAlert: true }, { id: 'DM', name: 'Digital marketing', hideAlert: true }, { id: 'BOTH', name: 'Both', hideAlert: true }]
	deliverModeFieldId = "deliveryModeId";
}